import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Icon,
  Select,
  Flex,
  useBreakpointValue,
  Spinner,
} from "@chakra-ui/react";
import {
  CheckCircleIcon,
  WarningIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import axiosInstance from "../../config/axiosInstance";

const getStatusIcon = (tailor) => {
  if (tailor.totalAssigned > 0) {
    return <CheckCircleIcon color="green.400" />;
  } else {
    return <WarningIcon color="yellow.400" />;
  }
};

const Tailor = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10);
  const [loading, setLoading] = useState(false);

  const fetchTailors = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `/api/stats/assigned-tailor-stats?page=${page}&limit=${limit}`
      );
      setData(res.data.stats || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error("Failed to fetch tailor stats:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTailors();
  }, 
   // eslint-disable-next-line
  [page]);

  return (
    <Box p={4} overflowX="auto">
      <Box
        bg="white"
        rounded="md"
        boxShadow="sm"
        overflowX="auto"
        p={isMobile ? 2 : 4}
      >
        <Table variant="simple" size="md">
          <Thead>
            <Tr>
              <Th>Master</Th>
              <Th>Assigned</Th>
              <Th>Pending</Th>
              <Th>Cancel</Th>
              <Th>Completed</Th>
            </Tr>
          </Thead>
          <Tbody>
            {loading ? (
              <Tr>
                <Td colSpan={4} textAlign="center">
                  <Spinner />
                </Td>
              </Tr>
            ) : data.length === 0 ? (
              <Tr>
                <Td colSpan={4}>No data found</Td>
              </Tr>
            ) : (
              data.map((tailor, idx) => (
                <Tr key={idx}>
                  <Td>{tailor?.name}</Td>
                  <Td>{getStatusIcon(tailor)}</Td>
                  <Td>{tailor?.pending}</Td>
                  <Td>{tailor?.cancelled}</Td>
                  <Td>{tailor?.completed}</Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>

        {/* Pagination */}
        <Flex
          mt={4}
          justify="space-between"
          align="center"
          flexWrap="wrap"
          gap={2}
        >
          <Text fontSize="sm">
            <Text as="span" color="green.500" fontWeight="semibold">
              {Math.min((page - 1) * limit + 1, limit * totalPages)} -{" "}
              {Math.min(page * limit, limit * totalPages)}
            </Text>{" "}
            of {limit * totalPages} Records
          </Text>

          <Flex align="center" gap={2}>
            <Text fontSize="sm">The page on</Text>
            <Select
              size="sm"
              width="60px"
              value={page}
              onChange={(e) => setPage(Number(e.target.value))}
            >
              {Array.from({ length: totalPages }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </Select>
            <Icon
              as={ChevronLeftIcon}
              cursor={page > 1 ? "pointer" : "not-allowed"}
              onClick={() => page > 1 && setPage(page - 1)}
            />
            <Icon
              as={ChevronRightIcon}
              cursor={page < totalPages ? "pointer" : "not-allowed"}
              onClick={() => page < totalPages && setPage(page + 1)}
            />
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Tailor;
